module.exports = __webpack_public_path__ + "img/上汽大众.png";